export default`
  min-width: initial;
  width: 4rem;
  height: 4rem;
  padding: 1.3rem;
  position: relative;
  margin: 0 0 0 auto;
  right: 10;
  top: 10;
  border: 1px solid rgba(225,227,244,1);
  border-radius: 4rem;
  cursor: pointer;
  z-index: 10;

  & > div {
    width: 1.2rem;
    height: 1.2rem;
  }

  svg path {
    stroke: none;
    fill: #686677;
  }

  &:hover {
    padding: 1.5rem;

    & > div {
      width: 0.8rem;
      height: 0.8rem;
    }

    border-color: rgba(72, 53, 198, 1);

    svg path {
      stroke: none;
      fill: rgba(72, 53, 198, 1);
    }
  }
`;
